<style>
	 @import '@/assets/css/custom.css';
</style>

<template>
	<div>
		<Breadcrumbs main="Device Renewal" title="Upcoming Expire Devices" />
 
		<div class="container-fluid">
			
			<div class="card">
				<div class="card-body">

                    <div class="col-md-12 project-list filter-sort">
						<div class="row">
							<div class="col-md-6 d-flex">
								<label class="d-flex listing-length"><span>Show</span>
									<select class="form-select" v-model="listing_length" @change="fetchUpcomingExpiryDevices()">
										<option value="20">20</option>
										<option value="30">30</option>
										<option value="50">50</option>
										<option value="100">100</option>
										<option value="200">200</option>
									</select>
									<span>entries</span>
								</label>
							</div>
							<div class="col-md-3 mb-2">
								
							</div>
							<div class="col-md-3">
								<input type="text" class="form-control" placeholder="IMEI" v-model="keyword" @keyup="fetchUpcomingExpiryDevices()"/>
							</div>
						</div>
					</div>
								
					<div class="table-responsive product-table">
						<table class="display" id="basic-1" >
							<thead>
								<tr align="center">
									<th>IMEI</th>
									<th>ICCID</th>
									<th>Expire On</th>
                                    <th>Vehicle</th>
									<th>Dealer</th>
                                    <th>Action</th>
								</tr>
							</thead>

							<tbody v-if="Boolean(devices.length)">
								<tr v-for="(device) in devices" :key="device.id" align="center">
                                    <td>{{ device.uniqueid }}</td>
									<td>{{ device.iccid }}</td>
									<td>{{ device.expirationtime }}</td>
                                    <td>{{ device.vehicle_no }}</td>
                                    <td>{{ device.dealer_name }}<br>
										{{ device.dealer_contact }}
									</td>
                                    <td>
										<button class="btn btn-warning btn-sm mt-2 me-2 mb-2" type="button" data-original-title="test" v-if="device.recharge_status != 1" @click="rechargeModal(device)">Update</button>
										<router-link :to="{ name: 'update_vehicle_data',params:{imei:device.uniqueid} }" class="btn btn-primary btn-sm me-2" v-if="!device.vehicle_no">Add Vehicle</router-link><br>
										<a class="btn btn-success btn-sm mt-2 me-2 mb-2" @click="renewDevice(device)" v-if="device.renewal_status == 2 && device.recharge_status == 1">Renew</a>
									</td>
								</tr>

							</tbody>
							<tbody v-else>
								<tr>
									<td colspan="12" align="center">No data available</td>
								</tr>
							</tbody>

						</table>
					</div>

					<!----pagination starts --->
					<caption v-if="Boolean(devices.length)" class="float-start mt-2 d-block d-lg-inline">Showing {{this.from}} to {{this.to}} of {{this.total}} entries</caption>
					<nav aria-label="Page navigation" class="mt-2 float-end">
						<ul class="pagination">
							<li class="page-item" v-bind:class="[{ disabled: !page.url }, { active: page.active }]" v-for="(page, index) in pagination" :key="page.label">
								<a class="page-link" href="#" @click.prevent="fetchUpcomingExpiryDevices(page.url + '&limit=' + listing_length  + '&keyword=' + keyword)" tabindex="-1">
									<span v-if="index == 0">Prev</span>
									<span v-else-if="index == pagination.length - 1">Next</span>
									<span v-else>{{ page.label }}</span>
								</a>
							</li>
						</ul>
					</nav>  
					<!----pagination ends --->
                </div>

			</div>
		</div>

		<DynamicModal :title="modal_title">
			<template #body>
				<form @submit.prevent="updateRemark" enctype="multipart/form-data" @hidden="clearForm()">

					<div class="col-md-12 form-group mb-2">
						<label class="control-label">Remarks<span class="text-danger">*</span></label>
						<textarea class="form-control" v-model="remark"></textarea>
					</div>

					<div class="col-md-12 form-group mt-3">
						<button type="submit" class="btn btn-primary me-3" >{{ button_title }}</button>
						<button class="btn btn-light" type="button" @click="closeModal()">Close</button>
					</div>
				</form>
			</template>
		</DynamicModal>

   </div>
</template>


<script>
import { onMounted } from 'vue'
import {Modal} from "bootstrap"
import DynamicModal from '@/components/dynamic_modal.vue'
	let dynamicmodal;

	export default {
		name: "Renewed Devices",
		components: {
			DynamicModal
		},
		setup(){
			onMounted(() => {
				dynamicmodal = new Modal(document.getElementById('dynamicmodal'));
			})

			const showModal = () => {
				dynamicmodal.show();
			}

			const hideModal = () => {
				dynamicmodal.hide();
			}

			return {
				showModal, hideModal
			}
		},
		
		data() {

			return {
				modal_title: "Update Status",
				button_title: "Save",

				pagination: {},
				
				keyword: "",
				listing_length: 10,
				token: "",
				devices: [],
				remark:"",
                payment_status: "",

				device: 
				{
					id: "",
					user_name: "",
					payment_status: "",
				},
				device_id:"",

				pagination: {},

				complete_status: {
					id: "",
				},
				
				errors: {},
				
			};
		},
		mounted() {},

		created() {
			this.fetchUpcomingExpiryDevices();
		},

		methods: {

			getToken() {
				if (localStorage.getItem('airotrack_staff')) {
					var airotrack_staff =  JSON.parse(localStorage.getItem('airotrack_staff')); 
							
					if(airotrack_staff.token) {

						this.token = airotrack_staff.token;
						this.user = airotrack_staff;

					} else {
						this.$swal("", "Failed to fetch token, please login again", "error");
						this.$router.push({ name: "login" });
					}

				} else {
					this.$swal("", "Session expired, please login again", "error");
					this.$router.push({ name: "login" });
				}
			},

			fetchUpcomingExpiryDevices(page_url = null) {
				this.getToken();
				let url = "/staffs/upcomingExpiryDevices?limit=" + this.listing_length  + "&imei=" + this.keyword;
				page_url = page_url || url;
				this.active_page_url = page_url;
				this.$axios
					.get(page_url, { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						var responseData = res.data.data;
						console.log(responseData);
						this.devices = responseData.devices.data;
						this.pagination = responseData.devices.links;
						this.from = responseData.devices.from;
						this.to = responseData.devices.to;
						this.total = responseData.devices.total;
						
					})
					.catch((err) => console.log(err));
			},

			deactivateDevice(device) {
				this.deactivate = false;
				this.$swal({
					icon: 'warning',
					title:"Confirm",
					text:'Are you sure you want to deactivate this device?',
					showCancelButton: true,
					confirmButtonText: 'Yes',
					confirmButtonColor: '#e64942',
					cancelButtonText: 'No',
					position: "center",
					showConfirmButton: true,
					timer: '',
					toast: false,
					cancelButtonColor: '#efefef',
					}).then((result)=>{
					if(result.value){
						
					}
				});
			},

			renewDevice(device) {
				this.deactivate = false;
				this.$swal({
					icon: 'warning',
					title:"Confirm",
					text:'Are you sure you want to renew this device?',
					showCancelButton: true,
					confirmButtonText: 'Yes',
					confirmButtonColor: '#e64942',
					cancelButtonText: 'No',
					position: "center",
					showConfirmButton: true,
					timer: '',
					toast: false,
					cancelButtonColor: '#efefef',
					}).then((result)=>{
					if(result.value){
						
					}
				});
			},

			openModal() {
				this.showModal();
			},

			closeModal() {
				this.hideModal();
			},

			rechargeModal(device) {
                this.errors = {};
				this.device_id =device.id;
				this.modal_title = "Update Status";
				this.button_title = "Save";
				this.showModal();
            },

			closeModal() {
				this.hideModal();
				this.clearForm();
			},

			clearForm() {
				this.edit = false;
				this.modal_title = "Update Status";
				this.button_title = "Save";
				this.errors = {};
			},

			updateRemark() {
				this.loading = true;
				this.errors = {};

				this.$axios.post(
					"/staffs/updateRemark",
					{
						device_id: this.device_id,
						remark: this.remark,
					},
					{
						headers: {
							Authorization: `Bearer ${this.token}`,
						},
					}
				)
				.then((response) => {
					if (response.data.status === true || response.data.status === "true") {
						this.$swal("Success", response.data.message || "Device recharge updated successfully", "success")
							.then(() => {
								this.closeModal();
								this.fetchUpcomingExpiryDevices();
							});
					} else {
						this.$swal("Error", response.data.message || "Failed to update recharge", "error");
					}
				})
				.catch((error) => {
					console.error("API Error:", error);
					this.$swal("Error", "Something went wrong while updating recharge", "error");
				})
				.finally(() => {
					this.loading = false;
				});
			},


		},
	};
</script>
